(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-project', {
                parent: 'app',
                url: '/tr-project',
                data: {
                    authorities: ['PROJECT_SIDEBAR'],            
                    pageTitle: 'trakeyeApp.project.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project-detail', {
                parent: 'tr-project',
                url: '/tr-project/{id}',
                data: {
                    authorities: ["PROJECT_DETAIL"],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-detail.html',
                        controller: 'TrProjectDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrProject', function ($stateParams, TrProject) {
                        return TrProject.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-project',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-project.priority', {
                parent: 'tr-project',
                url: '/tr-projects/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project.attendance', {
                parent: 'tr-project',
                url: '/tr-projects/attendance/{login}/{fromTime}/{toTime}/{projectStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            projectStatus: $stateParams.projectStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project.new', {
                parent: 'tr-project',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['PROJECT_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-dialog.html',
                        controller: 'TrProjectDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-project.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-project/tr-project-work-flow.html',
                    controller: 'TrProjectWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        projectImages: []
                    };
                }]
            }
        })

        .state('tr-project.import', {
                parent: 'tr-project',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-import.html',
                        controller: 'TrProjectImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                        };
                    }
                }

            })
            .state('tr-project.edit', {
                parent: 'tr-project',
                url: '/Edit/{id}',
                data: {
                    authorities: ['PROJECT_EDIT'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-dialog.html',
                        controller: 'TrProjectDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrProject', function ($stateParams, TrProject) {
                        return TrProject.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-project',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-project.delete', {
                parent: 'tr-project',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-project/tr-project-delete-dialog.html',
                        controller: 'TrProjectDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrProject', function (TrProject) {
                                return TrProject.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-project', null, { reload: 'tr-project' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-project.fibercore', {
                parent: 'tr-project',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-fiber-core.html',
                        controller: 'TrProjectFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                        };
                    }
                }

            })

            .state('show-hide-project', {
                parent: 'report',
                url: '/show-hide-project',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/show-hide-project.html',
                        controller: 'ShowHideProjectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('project-tree', {
                parent: 'app',
                url: '/project-tree',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_ROLLOUT_ADMIN'],
                    pageTitle: 'trakeyeApp.asset.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/project-tree.html',
                        controller: 'ProjectTreeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();